import { DateTime } from 'luxon'
const $formateDate = function (date = '', opt) {
  const { format = 'yyyy-MM-dd' } = { ...opt }
  return DateTime.fromISO(date).toFormat(format)
}
let formateDate = {
  install: (app) => {
    app.config.globalProperties.$formateDate = $formateDate
    app.provide('formateDate', $formateDate)
  }
}

export default formateDate
